/**
 *  @class
 *  @function ProductSidePanelLinks
 */
if (!customElements.get('side-panel-links')) {
  class ProductSidePanelLinks extends HTMLElement {
    constructor() {
      super();
      this.links = this.querySelectorAll('button');
      this.drawer = document.getElementById('Product-Information-Drawer');
      this.buttons = this.drawer.querySelector('.side-panel-content--tabs');
      this.panels = this.drawer.querySelector('.side-panel-content--inner').querySelectorAll('.side-panel-content--tab-panel');
      this.body = document.body;
    }
    connectedCallback() {
      this.setupObservers();
    }
    disconnectedCallback() {

    }
    setupObservers() {
      this.links.forEach((item, i) => {
        item.addEventListener('click', (e) => {
          this.body.classList.add('open-cc');
          this.buttons.toggleActiveClass(i);
          this.drawer.classList.add('active');
          this.drawer.setAttribute('aria-hidden', 'false');
        });
      });

      const closeButtons = this.drawer.querySelectorAll('side-panel-close');
      closeButtons.forEach(btn => {
        btn.addEventListener('click', () => {
          this.drawer.setAttribute('aria-hidden', 'true');
        });
      });

      document.addEventListener('click', (e) => {
        if (!this.drawer.contains(e.target) && !this.contains(e.target) && this.drawer.classList.contains('active')) {
          this.drawer.setAttribute('aria-hidden', 'true');
        }
      });
    }
  }

  customElements.define('side-panel-links', ProductSidePanelLinks);
}